module.exports = __webpack_public_path__ + "img/br47.62e3fd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br47.jpg
// module id = 4iYH
// module chunks = 0